// Единая шкала отступов, типографики, радиусов и теней.
// Значения задаются здесь и только здесь: в компонентах используем theme.spacing(n),
// theme.typography.*, theme.radii.*, theme.shadows.*, theme.zIndex.* — без «магических» чисел.

// FE-07: шаг 4px. Любой отступ — кратен 4.
//
// ВНИМАНИЕ, миграция не завершена. На момент введения токенов в проекте
// сосуществовали две системы почти поровну: ~240 значений кратны 4
// (4/8/12/16/20/24) и ~228 кратны 5 (5/10/15/20/30), плюс 36 разовых
// значений (1, 2, 3, 6, 9, 14, 25, 66). Массовая замена сдвинула бы вёрстку
// на каждом экране, поэтому переводить нужно поэкранно и с проверкой глазами.
// Новый код пишем только через spacing().
const scale = [0, 4, 8, 12, 16, 24, 32, 48, 64];

// spacing(3) -> 12; spacing(2, 4) -> "8px 16px"
const spacing = (...steps) => {
  const px = steps.map(step => `${scale[step] ?? step * 4}px`);

  return px.length === 1 ? parseInt(px[0], 10) : px.join(" ");
};

// FE-05: девять ролей — других размеров в интерфейсе быть не должно.
// mobile — значения для ширин до breakpoints.xs.
const typography = {
  h1: { fontSize: 34, lineHeight: "40px", fontWeight: 700, letterSpacing: "-0.01em", mobile: { fontSize: 26, lineHeight: "32px" } },
  h2: { fontSize: 26, lineHeight: "32px", fontWeight: 700, mobile: { fontSize: 22, lineHeight: "28px" } },
  h3: { fontSize: 20, lineHeight: "26px", fontWeight: 600, mobile: { fontSize: 18, lineHeight: "24px" } },
  price: { fontSize: 24, lineHeight: "28px", fontWeight: 700, mobile: { fontSize: 20, lineHeight: "24px" } },
  body: { fontSize: 16, lineHeight: "24px", fontWeight: 400 },
  input: { fontSize: 16, lineHeight: "24px", fontWeight: 500 }, // 16px обязателен: иначе iOS зумит страницу при фокусе
  caption: { fontSize: 14, lineHeight: "20px", fontWeight: 400 },
  label: { fontSize: 13, lineHeight: "18px", fontWeight: 500 },
  button: { fontSize: 16, lineHeight: "20px", fontWeight: 600 },
};

// FE-19: три радиуса и две тени на весь проект.
const radii = {
  sm: 6, // бейдж, чип, поле
  md: 8, // кнопка
  lg: 12, // карточка, модальное окно
  pill: 999,
};

const shadows = {
  card: "0 1px 2px rgba(16, 24, 40, .06), 0 4px 12px rgba(16, 24, 40, .06)",
  pop: "0 8px 32px rgba(16, 24, 40, .14)", // дропдаун, модальное
};

// FE-31: одна лестница z-index, значения вне неё не заводим.
const zIndex = {
  content: 0,
  header: 100,
  dropdown: 200,
  overlay: 300,
  modal: 400,
  toast: 500,
};

// FE-23: минимальная зона нажатия на тач-устройствах.
const tapTarget = 44;

export { radii, scale, shadows, spacing, tapTarget, typography, zIndex };
